module.exports = __webpack_public_path__ + "img/survey-1.eaa2420c.svg";